import React from "react";
import ErrorLayer from "../components/ErrorLayer";


const ErrorPage = () => {
  return (
    <>
      {/* ErrorLayer */}
      <ErrorLayer />
    </>
  );
};

export default ErrorPage;
